import * as React from "react";
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { useTheme } from "@emotion/react";

const Reject = ({ reason, comment, handleRejectSubseller, handleChange, subSellerRejectReasonData }) => {
  const theme = useTheme();

  return (
    <>
    <FormControl variant="standard" sx={{ mt: 2 }}>
        <InputLabel
          id="rejection"
          sx={{
            fontSize: ".9rem",
            fontWeight: 400,
            lineHeight: "1.25rem",
            color: "#000",
          }}
        >
          Rejection reason (required)
        </InputLabel>
        <Select
          labelId="rejection"
          id="rejct-name"
          value={reason}
          onChange={(e) => handleChange(e,'reason')}
          sx={{
            fontSize: ".9rem",
            fontWeight: 400,
            lineHeight: "1.25rem",
            color: "#000",
            py: ".2rem",
          }}
          inputProps={{
            style: {
              borderBottom: `1px solid ${theme.palette.silverSand}`,
            },
          }}
          MenuProps={{}}
        >
          {subSellerRejectReasonData?.data?.map((name) => (
            <MenuItem
              key={name.sub_seller_rejection_reason_id}
              value={name.rejection_reason_en}
            >
              {name.rejection_reason_en}
            </MenuItem>
          ))}
        </Select>
        <TextField
          variant="standard"
          sx={{
            mt: 3,
            fontSize: ".9rem",
            fontWeight: 400,
            lineHeight: "1.25rem",
          }}
          value={comment}
          onChange={(e) => handleChange(e, 'comment')}
          label="Add comments (optional)"
          InputLabelProps={{ style: { color: "#000" } }}
          inputProps={{
            style: {
              borderBottom: `1px solid ${theme.palette.silverSand}`,
              color: "#000",
              padding: ".4rem 0",
              fontSize: ".9rem",
            },
          }}
        />
      </FormControl>
      <Button
        // disabled={!reason}
        variant="contained"
        sx={{
          borderRadius: 3,
          py: 1,
          ...(reason && {
            bgcolor: theme.palette.darkBlue,
            color: theme.palette.primary.contrastText,
            "&:hover": { backgroundColor: theme.palette.darkBlue },
            boxShadow: "0 0 1rem #ccc",
          }),
          mt: 4,
          fontSize: "1rem",
          textTransform: "none",
          lineHeight: "1.5rem",
          fontWeight: 600,
        }}
        onClick={handleRejectSubseller}
      >
        Reject Sub-Seller
      </Button>
    </>
  );
};

export default Reject;
